
import { assessmentHasImagesOrComments } from '@/shared/helpers';
import globalConstants from '../../shared/globalConstants';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import TrailerAssessment from '../../types/TrailerAssessment';
import TrailerAssessmentType from '../../types/TrailerAssessmentType';
import TrailerDamageLayout from './TrailerDamageLayout.vue';

export default defineComponent({
    components: { TrailerDamageLayout },
    data(): {
        type: keyof TrailerAssessment;
        subTypes: {
            driverTop: string;
            centerTop: string;
            passengerTop: string;
            driverBottom: string;
            centerBottom: string;
            passengerBottom: string;
        };
        typeAssessment: TrailerAssessmentType | undefined;
    } {
        return {
            type: globalConstants.trailer.assessmentTypes
                .lights as keyof TrailerAssessment,
            subTypes: {
                driverTop:
                    globalConstants.trailer.assessmentTypes.subTypes.driverTop,
                centerTop:
                    globalConstants.trailer.assessmentTypes.subTypes.centerTop,
                passengerTop:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .passengerTop,
                driverBottom:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .driverBottom,
                centerBottom:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .centerBottom,
                passengerBottom:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .passengerBottom,
            },
            typeAssessment: undefined,
        };
    },
    computed: {
        ...mapGetters({ trailerAssessment: 'trailerAssessment' }),
        driverTopButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.driverTop
            )
                ? 'active'
                : '';
        },
        centerTopButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.centerTop
            )
                ? 'active'
                : '';
        },
        passengerTopButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.passengerTop
            )
                ? 'active'
                : '';
        },
        driverBottomButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.driverBottom
            )
                ? 'active'
                : '';
        },
        centerBottomButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.centerBottom
            )
                ? 'active'
                : '';
        },
        passengerBottomButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.passengerBottom
            )
                ? 'active'
                : '';
        },
    },
    created() {
        if (this.trailerAssessment)
            this.typeAssessment = this.trailerAssessment[this.type];
    },
    methods: {
        driverTopTapped(): void {
            this.$router.push({
                path: `electricalAssessment/${this.subTypes.driverTop}`,
            });
        },
        centerTopTapped(): void {
            this.$router.push({
                path: `electricalAssessment/${this.subTypes.centerTop}`,
            });
        },
        passengerTopTapped(): void {
            this.$router.push({
                path: `electricalAssessment/${this.subTypes.passengerTop}`,
            });
        },
        driverBottomTapped(): void {
            this.$router.push({
                path: `electricalAssessment/${this.subTypes.driverBottom}`,
            });
        },
        centerBottomTapped(): void {
            this.$router.push({
                path: `electricalAssessment/${this.subTypes.centerBottom}`,
            });
        },
        passengerBottomTapped(): void {
            this.$router.push({
                path: `electricalAssessment/${this.subTypes.passengerBottom}`,
            });
        },
    },
});
